import KoreanLunarCalendar from "korean-lunar-calendar";

export function getDate(offset: number = 0) {
  const date = new Date();
  // offset만큼 일수를 더함 (음수면 과거, 양수면 미래)
  date.setDate(date.getDate() + offset);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString(); // 월은 0부터 시작하므로 +1
  const day = date.getDate().toString();

  return {
    full: `${year}년 ${month}월 ${day}일`,
    short: `${month}월 ${day}일`,
    timestamp: `${year}${month}${day}`,
    ymd: { year, month: parseInt(month), day: parseInt(day) },
  };
}

export const getGanjiToday = () => {
  const calendar = new KoreanLunarCalendar();
  const { year, month, day } = getDate().ymd;
  calendar.setSolarDate(year, month, day);

  const {
    year: gabjaYear,
    month: gabjaMonth,
    day: gabjaDay,
  } = calendar.getChineseGapja();

  return `${gabjaYear} ${gabjaMonth} ${gabjaDay}`;
};

export const getGanjiTomorrow = () => {
  const calendar = new KoreanLunarCalendar();
  const { year, month, day } = getDate(1).ymd;
  calendar.setSolarDate(year, month, day);

  const {
    year: gabjaYear,
    month: gabjaMonth,
    day: gabjaDay,
  } = calendar.getChineseGapja();

  return `${gabjaYear} ${gabjaMonth} ${gabjaDay}`;
};

// 행운의 색상
export const getRandomColor = () => {
  const colors = [
    { key: "red", kor: "빨간색" },
    { key: "orange", kor: "주황색" },
    { key: "yellow", kor: "노란색" },
    { key: "green", kor: "초록색" },
    { key: "blue", kor: "파란색" },
    { key: "navy", kor: "남색" },
    { key: "purple", kor: "보라색" },
    { key: "white", kor: "흰색" },
    { key: "black", kor: "검은색" },
  ];

  return colors[Math.floor(Math.random() * colors.length)];
};

export const getRandomTwoNumbers = (): string => {
  let num = Math.floor(Math.random() * 45) + 1;
  return num.toString();
};

// 오늘의 갑자
export const getGabja = (offset: number = 0) => {
  const calendar = new KoreanLunarCalendar();
  // getDate()로 오늘 날짜 정보 받아오기 (예: { year, month, day })
  const { year, month, day } = getDate().ymd;

  // Date 객체는 month가 0부터 시작하므로 조정해줘야 함
  const baseDate = new Date(year, month - 1, day);
  // offset만큼 일수를 더함 (offset이 음수이면 이전 날짜)
  baseDate.setDate(baseDate.getDate() + offset);

  // Date 객체에서 년, 월, 일을 추출 (월은 다시 1부터 시작하도록 보정)
  calendar.setSolarDate(
    baseDate.getFullYear(),
    baseDate.getMonth() + 1,
    baseDate.getDate()
  );

  // 갑자 문자열에서 "일"을 제거해서 반환
  return calendar.getKoreanGapja().day.replace("일", "");
};

export const getGabjaFromDate = (targetDate: Date) => {
  const calendar = new KoreanLunarCalendar();
  calendar.setSolarDate(
    targetDate.getFullYear(),
    targetDate.getMonth() + 1,
    targetDate.getDate()
  );

  return calendar.getKoreanGapja().day.replace("일", "");
};

export const getBirthDayJuFromString = (
  birthDate: string | null | undefined,
  solarType: "SOLAR" | "LUNAR" | "LUNAR_INTER" = "SOLAR"
) => {
  if (!birthDate) {
    return "신해";
  }

  const [yearStr, monthStr, dayStr] = birthDate.split('-');
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);

  if (!year || !month || !day) {
    return "신해";
  }

  const calendar = new KoreanLunarCalendar();

  if (solarType === "SOLAR") {
    // 양력인 경우 그대로 설정
    calendar.setSolarDate(year, month, day);
  } else {
    // 음력인 경우 (LUNAR 또는 LUNAR_INTER)
    const isLeapMonth = solarType === "LUNAR_INTER";
    calendar.setLunarDate(year, month, day, isLeapMonth);
  }

  return calendar.getKoreanGapja().day.replace("일", "");
};

export const isEmbedMode = () => {
  if (typeof window === "undefined") return false;
  return document.body.classList.contains("is-embed");
};

const getEmbedContextParam = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("embedCtx");
  } catch (error) {
    console.warn("[getEmbedContextParam] failed to parse embed context", error);
    return null;
  }
};

export const isEmbedModalContext = () => {
  if (typeof document !== "undefined" && document.body.classList.contains("is-embed-button")) {
    return true;
  }
  return getEmbedContextParam() === "modal";
};

export const requestParentResize = (delays: number[] = [0, 300, 600]) => {
  if (typeof window === "undefined") return;
  const parentIFrame = (window as unknown as { parentIFrame?: { size: () => void } }).parentIFrame;
  if (!parentIFrame || typeof parentIFrame.size !== "function") return;

  delays.forEach((delay) => {
    window.setTimeout(() => {
      parentIFrame.size();
    }, delay);
  });
};

export const scrollToTopForEmbed = (behavior: ScrollBehavior = "auto") => {
  if (typeof window === "undefined") return;

  window.scrollTo({ top: 0, left: 0, behavior });

  if (typeof document !== "undefined") {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  const mainElement = document.querySelector(".main_container main");
  if (mainElement instanceof HTMLElement) {
    mainElement.scrollTop = 0;
  }

  const parentIFrame = (window as unknown as {
    parentIFrame?: {
      scrollToOffset?: (x: number, y: number) => void;
    };
  }).parentIFrame;

  const shouldControlParentScroll = !isEmbedModalContext();

  if (shouldControlParentScroll && parentIFrame && typeof parentIFrame.scrollToOffset === "function") {
    parentIFrame.scrollToOffset(0, 0);
  }

  if (typeof window !== "undefined" && window.parent && window.parent !== window) {
    try {
      window.parent.postMessage(
        {
          type: "SAJU_EMBED_SCROLL_TOP",
          source: "today-saju-embed",
        },
        "*"
      );
    } catch (error) {
      console.warn("[scrollToTopForEmbed] postMessage failed", error);
    }
  }
};
